export default "__VITE_ASSET__BF_ia4zd__"